import axios from 'axios';
import { BackEndVersion } from 'types';
import mainVersionOneService from './mainVersionOneService';

const CancelToken = axios.CancelToken;

let highlightCancel;
export let searchCancel;

export function searchAutoComplate(portId: number, backEnd: BackEndVersion, data) {
    return mainVersionOneService
        .post(`search/${portId}/autoComplate`, { ...data, backEnd })
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function searchNumbers(execute: string, portId: number,  data) {
    if (execute === 'search') {
        if (searchCancel !== undefined) {
            searchCancel();
        }
    } else {
        if (highlightCancel !== undefined) {
            highlightCancel();
        }
    }

    return mainVersionOneService
        .post(
            `search/${portId}/getData?rand=${new Date().getTime()}`,
            { ...data, get: 'numbers' },
            {
                cancelToken: new CancelToken(function executor(c) {
                    if (execute === 'search') {
                        searchCancel = c;
                    } else {
                        highlightCancel = c;
                    }
                }),
            }
        )
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function searchIds(execute: string, portId: number, data) {
    if (execute === 'search') {
        if (searchCancel !== undefined) {
            searchCancel();
        }
    } else {
        if (highlightCancel !== undefined) {
            highlightCancel();
        }
    }

    return mainVersionOneService
        .post(
            `search/${portId}/getData?rand=${new Date().getTime()}`,
            { ...data, get: 'id' },
            {
                cancelToken: new CancelToken(function executor(c) {
                    if (execute === 'search') {
                        searchCancel = c;
                    } else {
                        highlightCancel = c;
                    }
                }),
            }
        )
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function searchData(execute: string, portId: number,   data) {
    if (execute === 'search') {
        if (searchCancel !== undefined) {
            searchCancel();
        }
    } else {
        if (highlightCancel !== undefined) {
            highlightCancel();
        }
    }

    return mainVersionOneService
        .post(
            `search/${portId}/getData?rand=${new Date().getTime()}`,
            { ...data, get: 'data' },
            {
                cancelToken: new CancelToken(function executor(c) {
                    if (execute === 'search') {
                        searchCancel = c;
                    } else {
                        highlightCancel = c;
                    }
                }),
            }
        )
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}
